import { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../services/firebase";
import { Link } from "react-router-dom";

import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';

import SimpleAuthNavbar from '../SimpleAuthNavbar'

function ForgotPasswordPage() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);
    const [isSending, setIsSending] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSending(true);
        setMessage(null);
        setError(null);

        try {
            await sendPasswordResetEmail(auth, email);
            setMessage("Password reset email sent. Please check your inbox.");
        } catch (err) {
            console.error("Reset email error:", err);
            switch (err.code) {
                case 'auth/user-not-found':
                    setError("No user found with this email.");
                    break;
                case 'auth/invalid-email':
                    setError("Invalid email address.");
                    break;
                default:
                    setError("Failed to send reset email. Please try again.");
            }
        } finally {
            setIsSending(false);
        }
    };

    return (
        <>
            <SimpleAuthNavbar />
            <Container className="mt-5">
                <h2 className="text-center">Forgot Password</h2>
                {message && <Alert variant="success">{message}</Alert>}
                {error && <Alert variant="danger">{error}</Alert>}

                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="formEmail">
                        <Form.Label>Email address</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </Form.Group>

                    <Button variant="primary" type="submit" disabled={isSending} className="w-100">
                        {isSending ? "Sending..." : "Send Reset Email"}
                    </Button>
                </Form>

                <div className="mt-3 text-center">
                    <Link to="/auth/login">Back to Login</Link>
                </div>
            </Container>
        </>
    );
}

export default ForgotPasswordPage;
